(() => {
  if (window.oeookDealsJournal) return;
  window.oeookDealsJournal = true;
  const instances = new WeakMap();
  const DAY = 86400000;
  const parse = value => /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}(?::\d{2})?(?:Z|[+-]\d{2}:\d{2})$/.test(value || '') ? Date.parse(value) : NaN;
  function schedule(startValue, endValue, now) {
    const start = startValue ? parse(startValue) : -Infinity;
    const end = parse(endValue);
    const valid = Number.isFinite(end) && (!startValue || Number.isFinite(start)) && start < end;
    return { start, end, valid, phase: !valid ? 'invalid' : now < start ? 'upcoming' : now >= end ? 'ended' : 'active' };
  }
  function init(root) {
    if (instances.has(root)) return;
    const tabs = [...root.querySelectorAll('[data-r5-tab]')];
    const panel = root.querySelector('[data-r5-panel]');
    const clock = root.querySelector('[data-r5-clock]');
    const progress = root.querySelector('[data-r5-window]');
    const focused = Boolean(root.querySelector('[data-r5-focused]'));
    let selected = 'today';
    let renderedKey = root.dataset.initialContent === 'current' ? 'today:current:' : undefined;
    const listeners = new AbortController();
    const dateText = time => new Intl.DateTimeFormat(document.documentElement.lang || 'en', { dateStyle: 'medium', timeStyle: 'short', timeZone: 'Asia/Shanghai' }).format(time);
    const messages = {
      upcoming: ['The next offer has not started', 'Check the start time above. Browse products at their current prices in the catalog.'],
      ended: ['This campaign has ended', 'Explore the catalog for current prices and new arrivals.'],
      invalid: ['No scheduled offers right now', 'Explore the catalog for current prices.'],
      next: ['The next drop is being prepared', 'No upcoming campaign has been announced yet.'],
      last: ['No last-chance offers right now', 'Offers appear here during the final 24 hours of a scheduled campaign.'],
    };
    function update() {
      const now = Date.now();
      const current = schedule(root.dataset.start, root.dataset.end, now);
      const next = schedule(root.dataset.nextStart, root.dataset.nextEnd, now);
      const nextConfigured = root.dataset.nextConfigured === 'true' && Number.isFinite(next.start) && next.valid;
      const enabled = root.dataset.scheduled === 'true';
      const catalog = root.closest('[data-campaign-root]')?.querySelector('.deal-catalog');
      if (catalog) catalog.hidden = enabled && current.phase !== 'active';
      let state = selected === 'next' ? next : current;
      root.dataset.phase = state.phase;
      let content = 'current';
      let message;
      if (selected === 'next') {
        content = 'next';
        if (!nextConfigured) message = 'next';
        else if (next.phase === 'ended') message = 'ended';
      } else if (selected === 'last') {
        if (!enabled || current.phase !== 'active' || current.end - now > DAY) message = 'last';
      } else if (enabled && ['upcoming', 'ended', 'invalid'].includes(current.phase)) {
        message = current.phase;
      }
      const key = [selected, content, message || ''].join(':');
      if (key !== renderedKey) {
        panel.replaceChildren(root.querySelector(`[data-r5-${message ? 'empty' : content}]`).content.cloneNode(true));
        if (message) {
          panel.querySelector('[data-r5-empty-heading]').textContent = messages[message][0];
          panel.querySelector('[data-r5-empty-copy]').textContent = messages[message][1];
        }
        renderedKey = key;
      }
      const activeTab = tabs.find(tab => tab.dataset.r5Tab === selected);
      tabs.forEach(tab => { tab.setAttribute('aria-selected', String(tab === activeTab)); tab.tabIndex = tab === activeTab ? 0 : -1; });
      const showTabs = !focused || nextConfigured;
      root.querySelector('[data-r5-tabs]').hidden = !showTabs;
      if (showTabs) {
        panel.setAttribute('role', 'tabpanel');
        panel.setAttribute('aria-labelledby', activeTab.id);
      } else {
        panel.removeAttribute('role');
        panel.removeAttribute('aria-labelledby');
      }
      panel.tabIndex = 0;
      // "Tomorrow" is accurate in the campaign's configured offset, not the visitor's day.
      const offsetMatch = (root.dataset.nextStart || '').match(/([+-])(\d{2}):(\d{2})$/);
      const offset = offsetMatch ? (offsetMatch[1] === '+' ? 1 : -1) * (Number(offsetMatch[2]) * 60 + Number(offsetMatch[3])) * 60000 : 0;
      const tomorrow = nextConfigured && next.phase === 'upcoming' && Math.floor((next.start + offset) / DAY) - Math.floor((now + offset) / DAY) === 1;
      tabs.find(tab => tab.dataset.r5Tab === 'next').textContent = tomorrow ? 'Tomorrow' : 'Upcoming';
      const showClock = selected === 'next' ? nextConfigured : enabled && current.valid;
      clock.hidden = !showClock;
      if (progress) progress.hidden = true;
      if (!showClock) return;
      const upcoming = state.phase === 'upcoming';
      const ended = state.phase === 'ended';
      const target = upcoming ? state.start : state.end;
      root.querySelector('[data-r5-status]').textContent = ended ? 'Campaign ended' : upcoming ? 'Campaign starts in' : state.end - now <= DAY ? 'Final 24 hours' : 'Campaign ends in';
      const date = root.querySelector('[data-r5-date]');
      date.dateTime = new Date(target).toISOString();
      date.textContent = `${upcoming ? 'Starts' : 'Ends'} ${dateText(target)} (UTC+8)`;
      root.querySelector('[data-r5-digits]').hidden = ended;
      const seconds = Math.max(0, Math.floor((target - now) / 1000));
      const values = [Math.floor(seconds / 86400), Math.floor(seconds % 86400 / 3600), Math.floor(seconds % 3600 / 60), seconds % 60];
      ['days', 'hours', 'minutes', 'seconds'].forEach((field, index) => { root.querySelector(`[data-r5-${field}]`).textContent = String(values[index]).padStart(2, '0'); });
      if (progress && state.phase === 'active' && Number.isFinite(state.start)) {
        progress.hidden = false;
        progress.querySelector('progress').value = Math.min(100, Math.max(0, (now - state.start) / (state.end - state.start) * 100));
      }
    }
    tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => { selected = tab.dataset.r5Tab; update(); }, { signal: listeners.signal });
      tab.addEventListener('keydown', event => {
        const target = event.key === 'ArrowRight' ? (index + 1) % tabs.length : event.key === 'ArrowLeft' ? (index + tabs.length - 1) % tabs.length : event.key === 'Home' ? 0 : event.key === 'End' ? tabs.length - 1 : -1;
        if (target < 0) return;
        event.preventDefault();
        tabs[target].focus();
        tabs[target].click();
      }, { signal: listeners.signal });
    });
    root.querySelector('[data-r5-tabs]').hidden = false;
    update();
    const timer = window.setInterval(() => {
      if (!root.isConnected) { cleanup(); return; }
      update();
    }, 1000);
    function cleanup() { window.clearInterval(timer); listeners.abort(); instances.delete(root); }
    instances.set(root, cleanup);
  }
  const mount = container => container.querySelectorAll('[data-r5-journal]').forEach(init);
  mount(document);
  document.addEventListener('shopify:section:load', event => mount(event.target));
  document.addEventListener('shopify:section:unload', event => event.target.querySelectorAll('[data-r5-journal]').forEach(root => instances.get(root)?.()));
})();
